import forge from "node-forge";

const LOGIN_KEY_ID = 'login-key-2026';
 
/*
 * This is PUBLIC information.
 * It is safe for this key to exist in the React JavaScript bundle.
 *
 * Replace this with the public key generated for your environment.
 */
const LOGIN_PUBLIC_KEY_PEM = `
-----BEGIN PUBLIC KEY-----
MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEArerVXuj50ooaDZxqcDPj
LxkLEBsS5GkuKCK1UISl+HMg61FXlSV4Sf6evvdI1NvfiP/ZlHpCFWCz7Omfh9OK
EkjhypS/owmlytjzCEeqDpBk11jVT+1Df81xBrV8GmRkg41iIdWY3H/Tlu07/vgr
YjYQjZQNgukR1GVO0lZ8deUO72s8bjGzDCZRs8P4+ufF4HWDihSqkFf6PxLU0rwo
VqPbzVO6FUX3af4a5tSTSyTOJYf/wEBlUYriOHx4PEcd+2pI6CU41X5Iyih1ErAe
45TBukDb339EDiS/o07BatpdVHh1PwuoJFQX8mUVsUYyIhzjY0p5x+XUao8mbi+b
DIY07UAhojt76Wfnd5jsYtBIBDiJ6cXpMcKki7ZZlGveRa1VVBB1qzPu7wn0Y2sb
aYXsASlAsf3rn9DfVTh5zDLTuQzh6aTChExwih8xiFvD/eSg7Xyr70TKfL0Ar6s+
9j8UApMGTSS3Dug7OaSFEtrIUwSsrDTH9N0+KDZ+nwGbAgMBAAE=
-----END PUBLIC KEY-----
`;
 
/**
 * Convert Base64 string to Uint8Array.
 */
function base64ToBytes(base64: string): Uint8Array {
  const binary = window.atob(base64);
 
  const bytes = new Uint8Array(binary.length);
 
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
 
  return bytes;
}
 
/**
 * Convert Uint8Array to Base64.
 */
function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
 
  const chunkSize = 0x8000;
 
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk: any = bytes.subarray(
      i,
      Math.min(i + chunkSize, bytes.length),
    );
 
    binary += String.fromCharCode(...chunk);
  }
 
  return window.btoa(binary);
}
 
/**
 * Convert PEM public key into ArrayBuffer suitable
 * for window.crypto.subtle.importKey().
 */
function pemToArrayBuffer(pem: string): ArrayBufferLike {
  const base64 = pem
    .replace('-----BEGIN PUBLIC KEY-----', '')
    .replace('-----END PUBLIC KEY-----', '')
    .replace(/\s/g, '');
 
  return base64ToBytes(base64).buffer;
}
 
/**
 * Import RSA public key.
 *
 * Important:
 * - RSA-OAEP
 * - SHA-256
 * - SPKI public-key format
 */
async function importPublicKey(): Promise<CryptoKey> {
  const keyData: any = pemToArrayBuffer(
    LOGIN_PUBLIC_KEY_PEM,
  );
 
  return window.crypto.subtle.importKey(
    'spki',
    keyData,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-256',
    },
    false,
    ['encrypt'],
  );
}
 
/**
 * Encrypt one login field.
 *
 * Protocol:
 *
 * AES-256-GCM
 * +
 * RSA-OAEP-SHA256 wrapped AES key
 */
export async function encryptLoginField(value: string): Promise<string> {
  try {
    const publicKey = forge.pki.publicKeyFromPem(LOGIN_PUBLIC_KEY_PEM);

    const aesKey = forge.random.getBytesSync(32);

    const nonce = forge.random.getBytesSync(12);

    const aesCipher = forge.cipher.createCipher("AES-GCM", aesKey);

    aesCipher.start({ iv: nonce, tagLength: 128 });
    aesCipher.update(forge.util.createBuffer(forge.util.encodeUtf8(value)));
    aesCipher.finish();
    const ciphertext = aesCipher.output.getBytes();
    const authenticationTag = aesCipher.mode.tag.getBytes();

    const ciphertextWithTag = ciphertext + authenticationTag;

    const encryptedAesKey = publicKey.encrypt(aesKey, "RSA-OAEP", {
      md: forge.md.sha256.create(),
      mgf1: { md: forge.md.sha256.create() },
    });
    const envelope = {
      version: "v2",
      key_id: "login-key-2026",
      encrypted_key: forge.util.encode64(encryptedAesKey),
      nonce: forge.util.encode64(nonce),
      ciphertext: forge.util.encode64(ciphertextWithTag),
    };

    const json = JSON.stringify(envelope);
    return forge.util.encode64(forge.util.encodeUtf8(json));
  } catch (error) {
    console.error("forge error: ", error);
    return "forge error";
  }
}

// export async function encryptLoginField(
//   value: string,
// ): Promise<string> {
//   if (!value) {
//     throw new Error(
//       'Login encryption value cannot be empty',
//     );
//   }
 
//   if (!window.crypto?.subtle) {
//     throw new Error(
//       'Web Crypto API is not available in this browser',
//     );
//   }
 
//   /*
//    * 1. Generate random AES-256 key.
//    */
//   const aesKey = await window.crypto.subtle.generateKey(
//     {
//       name: 'AES-GCM',
//       length: 256,
//     },
//     true,
//     ['encrypt'],
//   );
 
//   /*
//    * 2. Generate random 12-byte GCM nonce.
//    */
//   const nonce = window.crypto.getRandomValues(
//     new Uint8Array(12),
//   );
 
//   /*
//    * 3. Convert plaintext to UTF-8.
//    */
//   const plaintext = new TextEncoder().encode(
//     value,
//   );
 
//   /*
//    * 4. Encrypt using AES-256-GCM.
//    *
//    * Web Crypto returns:
//    *
//    * ciphertext + 16-byte authentication tag
//    */
//   const ciphertext = await window.crypto.subtle.encrypt(
//     {
//       name: 'AES-GCM',
//       iv: nonce,
//       tagLength: 128,
//     },
//     aesKey,
//     plaintext,
//   );
 
//   /*
//    * 5. Export AES key.
//    */
//   const rawAesKey =
//     await window.crypto.subtle.exportKey(
//       'raw',
//       aesKey,
//     );
 
//   /*
//    * 6. Import RSA public key.
//    */
//   const publicKey = await importPublicKey();
 
//   /*
//    * 7. Encrypt AES key using RSA-OAEP-SHA256.
//    */
//   const encryptedAesKey =
//     await window.crypto.subtle.encrypt(
//       {
//         name: 'RSA-OAEP',
//       },
//       publicKey,
//       rawAesKey,
//     );
 
//   /*
//    * 8. Build the same envelope expected by Python.
//    */
//   const envelope = {
//     version: 'v2',
//     key_id: LOGIN_KEY_ID,
 
//     encrypted_key: bytesToBase64(
//       new Uint8Array(encryptedAesKey),
//     ),
 
//     nonce: bytesToBase64(
//       nonce,
//     ),
 
//     ciphertext: bytesToBase64(
//       new Uint8Array(ciphertext),
//     ),
//   };
 
//   /*
//    * 9. Base64 encode the complete JSON envelope.
//    *
//    * This means the API still receives:
//    *
//    * username: "some-base64-string"
//    * password: "some-base64-string"
//    */
//   const envelopeJson = JSON.stringify(
//     envelope,
//   );
 
//   return window.btoa(
//     envelopeJson,
//   );
// }
 